import { Injectable, Inject } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { API_URL } from '../models/api-url.token';
import { IOskVm } from '../osk-vm.model';
import { IPaginatedResultOskVm } from '../paginated-result-osk-vm.model';
import { SortOrder } from '../sort-order.model';
@Injectable({ providedIn: 'root' })
export class OsksService {
  private readonly baseUrl: string;
  constructor(private http: HttpClient, @Inject(API_URL) private apiUrl: string) {
    this.baseUrl = `${this.apiUrl}/Osks`;
  }
  get(search: string, sortColumn: string, page?: number, pageSize?: number, sortOrder?: SortOrder, onlyPendingApproval = false): Observable<IPaginatedResultOskVm> {
    const headers = this.createHeaders();
    let params = new HttpParams();
    if (search !== undefined && search !== null) {
      params = params.set('search', search.toString());
    }
    if (page !== undefined && page !== null) {
      params = params.set('page', page.toString());
    }
    if (pageSize !== undefined && pageSize !== null) {
      params = params.set('pageSize', pageSize.toString());
    }
    if (sortColumn !== undefined && sortColumn !== null) {
      params = params.set('sortColumn', sortColumn.toString());
    }
    if (sortOrder !== undefined && sortOrder !== null) {
      // Plain enum name - JSON.stringify would send it wrapped in quotes and the API would
      // reject the value.
      params = params.set('sortOrder', sortOrder.toString());
    }
    if (onlyPendingApproval) {
      params = params.set('onlyPendingApproval', 'true');
    }
    return this.http.get<IPaginatedResultOskVm>(this.baseUrl, { headers, params });
  }
  private createHeaders(): HttpHeaders {
    let headers = new HttpHeaders();
    const token = localStorage.getItem('authToken');
    if (token) headers = headers.set('Authorization', `Bearer ${token}`);
    return headers;
  }
}
